import { useQuery } from '@tanstack/react-query'
import { adminQueries } from '../../../../api/admin'

/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const useAdminSociety = (societyId: string | undefined) => {
  const { data: societies, ...rest } = useQuery(
    adminQueries.getSocietiesByIds(societyId)
  )

  const society = societies && societies.length > 0 ? societies[0] : undefined

  return {
    adminSociety: society ?? undefined,
    ...rest,
  }
}
